import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { transformResponseGetPolicyRules } from './transformers'

const useFetchPolicyRules = ({ doInitialRequest = false, params } = {}) => {
  const {
    data: policyRulesData,
    fetchData: fetchPolicyRules,
    loading: gettingPolicyRules,
  } = useFetch(configurationServices.getPolicyRules, {
    doInitialRequest,
    params,
    transformResponse: transformResponseGetPolicyRules,
  })

  return { policyRulesData, fetchPolicyRules, gettingPolicyRules }
}

export default useFetchPolicyRules
